import { AuthConfig, OAuthStorage } from 'angular-oauth2-oidc';

export function clearTokensOnAuthConfigChange(config: AuthConfig, storageService: OAuthStorage): void {
  const storageKey = 'oauth_config_fingerprint';
  const currentFingerprint = `${config.clientId}|${config.issuer}`;
  const storedFingerprint = storageService.getItem(storageKey);
  if (storedFingerprint && storedFingerprint !== currentFingerprint) {
    storageService.removeItem('refresh_token');
    storageService.removeItem('access_token');
    storageService.removeItem('id_token');
  }
  storageService.setItem(storageKey, currentFingerprint);
}
